import { FC } from 'react';

import { Skeleton } from '@/components/ui/skeleton';

export const CustomersTableSkeleton: FC = () => (
  <div className='border-primary animate-pulse flex min-w-0 flex-1 flex-col overflow-hidden rounded-3xl border bg-white shadow-sm'>
    <div className='border-primary bg-muted flex h-12 items-center justify-between border-b px-6'>
      <Skeleton className='h-4 w-40' />
      <Skeleton className='h-4 w-28' />
    </div>
    <div className='border-primary flex flex-wrap items-center justify-between gap-4 border-b bg-white p-5'>
      <Skeleton className='h-9 min-w-[280px] flex-1' />
      <Skeleton className='h-4 w-32' />
    </div>
    <div className='flex-1 space-y-6 overflow-auto p-6'>
      <div className='border-primary overflow-hidden rounded-2xl border bg-white shadow-sm'>
        <div className='space-y-3 p-5'>
          {Array.from({ length: 6 }).map((_, index) => (
            <Skeleton
              key={index}
              className='h-12 w-full'
            />
          ))}
        </div>
      </div>
      <div className='grid grid-cols-1 gap-6 md:grid-cols-4'>
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton
            key={index}
            className='h-44 rounded-2xl'
          />
        ))}
      </div>
    </div>
  </div>
);
